import React, { useState, useRef, useEffect } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import calanderIcon from "../../assets/images/calander.svg";

const CustomDatePickerField = ({ name, value, onChange, disabled = false }) => {
  const [selectedDate, setSelectedDate] = useState(null);
  const [dayInput, setDayInput] = useState(""); // separate state for DD field
  const datePickerRef = useRef(null);
  const handleIconClick = () => {
    datePickerRef.current.setOpen(true); // open date picker popup
  };
  // Generate year options (current year ± 50 years)
  const years = Array.from(
    { length: 101 },
    (_, i) => new Date().getFullYear() - 50 + i
  );

  // Prefill from prop
  useEffect(() => {
    if (value) {
      const prefillDate = new Date(value);
      if (!isNaN(prefillDate)) {
        setSelectedDate(prefillDate);
        setDayInput(String(prefillDate.getDate()).padStart(2, "0"));
      }
    }
  }, [value]);
  // Sync DD field with selected date
  useEffect(() => {
    if (selectedDate) {
      setDayInput(String(selectedDate.getDate()).padStart(2, "0"));
    } else {
      setDayInput("");
    }
    // onChange(name, selectedDate, true);
  }, [selectedDate]);

  function numberToShortMonth(num) {
    const date = new Date(2000, num);
    return date.toLocaleString("en-US", { month: "short" });
  }

  return (
    <div className={` ${!disabled ? "datePickerSection" : "dateSection"}`}>
      {disabled ? (
        <>
          <input
            type="number"
            placeholder="DD"
            value={dayInput}
            disabled={disabled}
            style={styles.input}
            className={disabled ? "notAllowed" : ""}
          />
          <input
            type="text"
            placeholder="MM"
            value={
              selectedDate ? numberToShortMonth(selectedDate.getMonth()) : ""
            }
            disabled={disabled}
            style={styles.inputYYMM}
            className={disabled ? "notAllowed" : ""}
          />
          <input
            type="number"
            placeholder="YY"
            value={selectedDate ? selectedDate.getFullYear() : ""}
            disabled={disabled}
            style={styles.inputYYMM}
            className={disabled ? "notAllowed" : ""}
          />
        </>
      ) : (
        <>
          <div className="dateSection">
            {/* Day */}
            <input
              type="number"
              placeholder="DD"
              value={dayInput}
              disabled={disabled}
              onChange={(e) => {
                let val = e.target.value;
                setDayInput(val); // update input as user types
                const day = parseInt(val, 10);
                if (!isNaN(day) && day >= 1 && day <= 31) {
                  const newDate = selectedDate
                    ? new Date(selectedDate)
                    : new Date();

                  newDate.setDate(day);
                  setSelectedDate(newDate);
                  onChange(name, newDate, false);
                }
              }}
              style={styles.input}
              className={disabled ? "notAllowed" : ""}
            />
            {/* Month Dropdown */}
            <select
              value={selectedDate ? selectedDate.getMonth() : ""}
              disabled={disabled}
              onChange={(e) => {
                const month = parseInt(e.target.value, 10);
                const newDate = selectedDate
                  ? new Date(selectedDate)
                  : new Date();
                newDate.setMonth(month);
                setSelectedDate(newDate);
                onChange(name, newDate, false);
              }}
              style={styles.selectmm}
              placeholder="Month"
            >
              <option value="" disabled>
                Month
              </option>
              {Array.from({ length: 12 }).map((_, i) => (
                <option key={i} value={i}>
                  {numberToShortMonth(i)}
                </option>
              ))}
            </select>

            {/* Year Dropdown */}
            <select
              value={selectedDate ? selectedDate.getFullYear() : ""}
              onChange={(e) => {
                const year = parseInt(e.target.value, 10);
                const newDate = selectedDate
                  ? new Date(selectedDate)
                  : new Date();
                newDate.setFullYear(year);
                setSelectedDate(newDate);
                onChange(name, newDate, false);
              }}
              style={styles.selectyy}
              placeholder="Year"
              disabled={disabled}
            >
              <option value="" disabled>
                Year
              </option>
              {years.map((year) => (
                <option key={year} value={year}>
                  {year}
                </option>
              ))}
            </select>
          </div>
          {/* Hidden DatePicker (popup only) */}
          <div className="datePickerBlock">
            <DatePicker
              selected={selectedDate}
              onChange={(date) => {
                setSelectedDate(date);
                onChange(name, date, false);
              }}
              ref={datePickerRef}
              dateFormat="dd/MMM/yyyy"
              popperPlacement="bottom-start"
              customInput={<div />} // hide the actual input
              shouldCloseOnSelect
            />
            {/* Calendar Icon */}
            <button
              type="button"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                handleIconClick();
              }}
              onMouseDown={(e) => e.preventDefault()}
              style={{ cursor: "pointer" }}
            >
              <img src={calanderIcon} alt="calender" width={38} />
            </button>
          </div>
        </>
      )}
    </div>
  );
};

const styles = {
  input: {
    padding: "9px 12px",
    borderRadius: "6px",
    border: "1px solid #606264",
    backgroundColor: "#2e3033",
    color: "#fff",
    textAlign: "center",
    minWidth: "45px",
  },
  selectmm: {
    padding: "9px 0px 9px 12px",
    borderRadius: "6px",
    border: "1px solid #606264",
    backgroundColor: "#2e3033",
    color: "#fff",
    minWidth: "65px",
  },
  selectyy: {
    padding: "9px 0px 9px 12px",
    borderRadius: "6px",
    border: "1px solid #606264",
    backgroundColor: "#2e3033",
    color: "#fff",
    minWidth: "75px",
  },

  inputYYMM: {
    padding: "9px 12px",
    borderRadius: "6px",
    border: "1px solid #606264",
    backgroundColor: "#2e3033",
    color: "#fff",
    textAlign: "center",
    minWidth: "60px",
    cursor: "not-allowed",
  },
};

export default CustomDatePickerField;
